import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Typography, TextField, Box, Chip, CircularProgress } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import RefreshIcon from '@mui/icons-material/Refresh'; // Add this import for resend icon
import { sendCustomerOTPAPI,validateCustomerOtpAPI } from 'pages/authentication/components/AuthAPI';
import { setLoggedIn, setAppuserInfo, setuserprofileInfo } from 'store/slice/HeaderSlice';
import { setMlmUserObj, setSelectedTab } from 'store/slice/EcomSlice';
import { updateCartCustomerAPI } from '../ecom/EcomAPI';
import { setCartObj } from 'store/slice/EcomSlice';
import Cookies from 'js-cookie';
import { validMobileNumberEntry } from 'core/js/FormValidation';
import { inviteeLoginSuccessAPI } from 'api/CoreMlmmgmtWebServices';
import { openLoginModal } from 'store/slice/HeaderSlice';
import {updateLastLoginAPI} from 'api/CorePlatformserviceWebServices';

export default function MobileLogin() {
    const dispatch = useDispatch();
    const { inviteeMobileNumber } = useSelector((state) => state.ecomslice.mlm);
    const [mobileNumber, setMobileNumber] = useState(inviteeMobileNumber);
    const [otpReqId, setOtpReqId] = useState('');
    const [otp, setOtp] = useState('');
    const [enteredOtp, setEnteredOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [resendTimer, setResendTimer] = useState(0);
    const [sendingOtp, setSendingOtp] = useState(false); // Add loading state for Send OTP
    const [loggingIn, setLoggingIn] = useState(false); // Add loading state for Login
    const { userprofileInfo } = useSelector((state) => state.headerslice);

    // Move handleMobileChange function here, right after state declarations
    const handleMobileChange = (e) => {
        const inputValue = e.target.value;
        // Allow only numbers
        if (/^\d*$/.test(inputValue) && inputValue.length <= 10) {
            setMobileNumber(inputValue);
        }
    }

    const handleOtpChange = (e) => {
        const inputValue = e.target.value;
        // Clear error when user starts typing
        if (otpError) {
            setOtpError('');
        }
        // Allow only numbers, max 6 digits
        if (/^\d*$/.test(inputValue) && inputValue.length <= 6) {
            setEnteredOtp(inputValue);
        }
    }

    // Timer effect for resend functionality
    useEffect(() => {
        let interval = null;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer(timer => timer - 1);
            }, 1000);
        } else if (resendTimer === 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [resendTimer]);

    // Start timer when OTP is sent
    const startResendTimer = () => {
        setResendTimer(60); // 60 seconds = 1 minute
    }

    // Format timer display
    const formatTimer = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    useEffect(() => {
        if (Cookies.get('anonymousId') !== undefined && userprofileInfo.rolename !== "MLM_CUSTOMER")
            updateCartCustomerAPI({
                "anonymousId": Cookies.get('anonymousId')
            }, updateCartCustomerSuccess, updateCartCustomerFailure
            )
    }, [userprofileInfo?.email])

    const updateCartCustomerSuccess = (apiResponse) => {
        dispatch(setCartObj(apiResponse.cartInfo));
    }
    const updateCartCustomerFailure = (errMsg) => {
        console.log(' !!! Error !!! ' + errMsg);
    }

    const setNameValue = (e) => {
        const { name, value } = e.target;
        setMobileNumber(value);
    }

    const loginCustomer = () => {
        setSendingOtp(true); // Start loading
        sendCustomerOTPAPI(mobileNumber, getOTPsuccess, getOTPfailure);
    }

    const getOTPsuccess = (apiResponse) => {
        setOtpReqId(apiResponse.otpResponse.id);
        startResendTimer(); // Start timer when OTP is sent
        setSendingOtp(false); // Stop loading
        // setOtp(apiResponse.otpResponse.otp);
    }

    const resendOTP = () => {
        if (resendTimer === 0) {
            setSendingOtp(true); // Start loading for resend
            sendCustomerOTPAPI(mobileNumber, getOTPsuccess, getOTPfailure);
            setOtpError(''); // Clear any existing errors
        }
    }

    const getOTPfailure = (errMsg) => {
        setSendingOtp(false); // Stop loading on error
        alert("!!! ERROR ===>" + errMsg);
    }

    const validateCustomerOTPsuccessCallBack = (data) => {
        localStorage.setItem("JWT", data.accesstoken);
        updateLastLoginAPI({}, () => { }, () => { });
        dispatch(setLoggedIn(true));
        dispatch(setAppuserInfo(data.appuserInfo));
        dispatch(setuserprofileInfo(data.userprofileInfo));
        fetchMlmUserObj();
        dispatch(setSelectedTab("ADDRESS"))
        dispatch(openLoginModal(false));
        setLoggingIn(false); // Stop loading
    }

    const failuerCallback = (errMsg) => {
        setLoggingIn(false); // Stop loading on error
        try {
            // Parse the error message if it's a JSON string
            const errorData = typeof errMsg === 'string' ? JSON.parse(errMsg) : errMsg;

            if (errorData && errorData.appError) {
                // Set the specific error message from the API
                setOtpError(errorData.appError.errorMsg);
            } else {
                // Fallback to the original error message
                setOtpError(errMsg);
            }
        } catch (parseError) {
            // If parsing fails, show the original error message
            setOtpError(errMsg);
        }
    }

    const changeMobileNumber = () => {
        setOtpReqId('');
        setOtp('');
        setEnteredOtp('');
        setOtpError('');
        setResendTimer(0); // Reset timer when changing mobile number
        setSendingOtp(false); // Reset loading state
        setLoggingIn(false); // Reset loading state
    }

    const getMlmUserSuccess = (apiResponse) => {
        dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
    }

    const getMLMuserFailure = (errMsg) => {
        //alert("!!! ERROR - Unable to fetch MLM User");
    }

    const fetchMlmUserObj = () => {
        inviteeLoginSuccessAPI({}, getMlmUserSuccess, getMLMuserFailure);
    }

    const handleLogin = () => {
        setLoggingIn(true); // Start loading
        validateCustomerOtpAPI(otpReqId, enteredOtp, validateCustomerOTPsuccessCallBack, failuerCallback);
    }

    return (
        <>
            <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'white', p: 1, borderRadius: 2 }}>
                <Grid item lg={12} xs={12} sx={{ padding: 1, mb: 1 }}>
                    <Typography variant="h4" color="primary.darker">
                        {otpReqId ? 'Enter OTP' : 'Your Mobile Number'}
                    </Typography>
                </Grid>
                <Grid item lg={12} xs={12} sx={{ width: '100%', backgroundColor: 'white', padding: 1, borderRadius: 2 }} >
                    <Grid container direction="row" justifyContent="space-between" spacing={2}>
                        <Grid item lg={12} sx={{ width: '100%' }} >
                            {!otpReqId ? (
                                <>
                                    <TextField
                                        size="small"
                                        placeholder="Enter your Mobile Number"
                                        required={true}
                                        label="Enter your Mobile Number"
                                        name="mobilenumber1"
                                        value={mobileNumber}
                                        onChange={handleMobileChange}
                                        sx={{
                                            width: '100%',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 3,
                                                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                                '& fieldset': {
                                                    borderColor: 'primary.dark',
                                                    borderWidth: 2,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'primary.dark',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'primary.dark',
                                                    borderWidth: 2,
                                                },
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'primary.dark',
                                                fontWeight: 600,
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: 'primary.dark',
                                            },
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '14px',
                                                opacity: 0.7,
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <PhoneIcon sx={{ color: 'primary.main', mr: 1 }} />
                                            ),
                                            style: { fontSize: 18 }
                                        }}
                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                                    />
                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'right' }}>
                                        We will send you a <span style={{ color: "#1976d2" }}>WhatsApp OTP </span> to verify your mobile number.
                                    </Typography>
                                </>
                            ) : (
                                /* When OTP is requested - Show mobile number as label with edit option */
                                <>
                                    {/* Mobile Number Label with Edit and Resend Options */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1, backgroundColor: 'secondary.100', borderRadius: 2 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon sx={{ color: 'primary.main', mr: 1 }} />
                                            <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.darker' }}>
                                                {mobileNumber}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                                            <Button
                                                variant="text"
                                                size="small"
                                                startIcon={<EditIcon />}
                                                onClick={changeMobileNumber}
                                                sx={{
                                                    minWidth: 'auto',
                                                    color: 'primary.main',
                                                    fontSize: '12px',
                                                    padding: '2px 8px',
                                                    '&:hover': {
                                                        backgroundColor: 'primary.100'
                                                    }
                                                }}
                                            >
                                                Edit
                                            </Button>
                                            <Button
                                                variant="text"
                                                size="small"
                                                startIcon={sendingOtp ? <CircularProgress size={12} color="inherit" /> : <RefreshIcon />}
                                                onClick={resendOTP}
                                                disabled={resendTimer > 0 || sendingOtp}
                                                sx={{
                                                    minWidth: 'auto',
                                                    color: (resendTimer > 0 || sendingOtp) ? 'text.disabled' : 'primary.main',
                                                    fontSize: '12px',
                                                    padding: '2px 8px',
                                                    '&:hover': {
                                                        backgroundColor: (resendTimer > 0 || sendingOtp) ? 'transparent' : 'primary.100'
                                                    },
                                                    '&.Mui-disabled': {
                                                        color: 'text.disabled'
                                                    }
                                                }}
                                            >
                                                {sendingOtp ? 'Sending...' : resendTimer > 0 ? `Resend (${formatTimer(resendTimer)})` : 'Resend'}
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'right' }}>
                                        <span style={{ color: "#1976d2" }}>WhatsApp OTP </span> is sent to {mobileNumber}.
                                    </Typography>

                                    {/* OTP Field */}
                                    <TextField
                                        size="small"
                                        placeholder="Enter OTP"
                                        required={true}
                                        label="Enter OTP"
                                        name="otp"
                                        value={enteredOtp}
                                        onChange={handleOtpChange}
                                        autoFocus
                                        error={!!otpError} // Show error state if there's an error
                                        sx={{
                                            mt: 5,
                                            width: '100%',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 3,
                                                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                                '& fieldset': {
                                                    borderColor: otpError ? 'error.main' : 'primary.light',
                                                    borderWidth: 2,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: otpError ? 'error.main' : 'primary.main',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: otpError ? 'error.main' : 'primary.dark',
                                                    borderWidth: 2,
                                                },
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: otpError ? 'error.main' : 'primary.main',
                                                fontWeight: 600,
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: otpError ? 'error.main' : 'primary.dark',
                                            },
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '14px',
                                                opacity: 0.7,
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <LockIcon sx={{ color: otpError ? 'error.main' : 'primary.main', mr: 1 }} />
                                            ),
                                            style: { fontSize: 18 }
                                        }}
                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
                                    />

                                    {/* Error Message Display */}
                                    {otpError && (
                                        <Typography
                                            variant="caption"
                                            color="error"
                                            sx={{
                                                mt: 0.5,
                                                display: 'block',
                                                fontSize: '12px',
                                                fontWeight: 500
                                            }}
                                        >
                                            {otpError}
                                        </Typography>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ backgroundColor: 'secondary.lighter', paddingTop: 2 }}>
                {!otpReqId ? (
                    <Button
                        variant="contained"
                        disabled={mobileNumber.length !== 10 || sendingOtp}
                        onClick={loginCustomer}
                        startIcon={sendingOtp ? <CircularProgress size={16} color="inherit" /> : null}
                        sx={{ minWidth: 120 }}
                    >
                        {sendingOtp ? 'Sending...' : 'Send OTP'}
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        disabled={enteredOtp.length < 1 || loggingIn}
                        onClick={handleLogin}
                        startIcon={loggingIn ? <CircularProgress size={16} color="inherit" /> : null}
                        sx={{ minWidth: 120 }}
                    >
                        {loggingIn ? 'Logging In...' : 'Log In'}
                    </Button>
                )}
            </Grid>
        </>
    )
}